import { createEntityRowAction } from '@/utils/createEntityRowAction';

import {
  CACHE_KEY_LIST_HISTORIAN_OFFICES,
  ROUTE_PATH_HISTORIAN_OFFICES,
  SECURITY_KEY_CNAE_HISTORIAN_OFFICES
} from '../contants/historianOffices';
import HistorianOfficesApiService from '../services/HistorianOfficesApiService';

export const { Component, renderEntityActions: renderActions } = createEntityRowAction(
  HistorianOfficesApiService,
  'name',
  CACHE_KEY_LIST_HISTORIAN_OFFICES,
  'historian',
  ROUTE_PATH_HISTORIAN_OFFICES,
  SECURITY_KEY_CNAE_HISTORIAN_OFFICES
);
